<template>
  <v-container fluid>
    <v-app-bar app elevate-on-scroll color="white">
      <v-btn icon @click="$router.go(-1)">
        <v-icon dark>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>Forgot Password?</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-row justify="center" class="text-center">
      <v-col cols="12" sm="6" md="4">
        <v-card v-if="didSubmit" elevation="0" outlined color="transparent">
          <v-card-text>
            <p>
              We sent you an email with instructions to reset your password.
              Please check your inbox and make sure the email is not in the SPAM
              folder.
            </p>
          </v-card-text>
        </v-card>
        <v-card v-else elevation="0" outlined color="transparent">
          <v-card-text>
            <v-card class="mb-4" v-if="error">
              <v-card-text>
                <p class="mb-0 red--text">
                  <b>{{ error.title }}:</b> {{ error.message }}
                </p>
              </v-card-text>
            </v-card>
            <v-form
              id="login-form"
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="onSubmit"
            >
              <p>
                Please enter your email and we will send you instructions to set
                a new password.
              </p>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                type="email"
                prepend-icon="mdi-email"
              ></v-text-field>
            </v-form>
            <v-btn
              type="submit"
              :disabled="loading"
              :loading="loading"
              color="primary"
              form="login-form"
              rounded
              >Reset Password</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    didSubmit: false
  }),
  computed: {
    ...mapState('common', ['error', 'loading'])
  },
  mounted() {
    this.$store.dispatch('analytics/logScreen', {
      name: 'forgot-password'
    })
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('auth/resetPassword', { email: this.email })
          .then(() => {
            this.$refs.form.reset()
            this.didSubmit = true
          })
      }
    }
  }
}
</script>
